import { StyledHero, ContentWrapper } from "./styles/StyledHero";
import Arrow from "../../../../shared/assets/img/hero/arrow.svg";
import { useTranslation } from 'react-i18next';
import {modalActions, ModalType} from "../../../../entities/modal";
import {routes, wsWeddingRoutes} from "../../../../app/providers/router/routes";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useShallowSelector} from "../../../../shared/hooks";
import {userSelector} from "../../../../entities/user";
import {weddingSelector} from "../../../../entities/wedding";
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';
import {Stack, styled} from "@mui/material";

export const ButtonOther = styled('button')`
  border: 1px solid transparent!important;
  box-shadow: none!important;
  &:hover {
    border: 1px solid #ccc!important;
  }
  svg {
      position: absolute;
      top: 17px;
      right: 20px
  }
`;
export const ButtonRitual = styled('button')`
  svg {
      position: absolute;
      top: 15px;
      right: 20px
  }
`;
const Hero = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: userId } = useShallowSelector(userSelector.getUser);
  const { state } = useShallowSelector(weddingSelector.getWedding);
  const { t } = useTranslation();

  const handleButtonClick = () => {
    if (!userId) {
      dispatch(
          modalActions.openModal({
            type: ModalType.ConnectWallet,
          }),
      );
    } else {
      navigate(state ? wsWeddingRoutes[state] : routes.connection.path);
    }
  };
  const handleButtonClickGift = () => {
    navigate('/help-vows');
  };
  const handleButtonClickMedia = () => {
    navigate('/help-vows');
  };
  return (
    <StyledHero>
      <ContentWrapper>
        <h1>
          {t('hero_title')} <br/> {t('hero_title_1')}
        </h1>
        <p>
          {t('hero_p')}<br/>
          {t('hero_p1')}<br/>{t('hero_p2')}
        </p>
        <Stack sx={{
          flexDirection: {sm: 'column', md: 'row'},
          marginTop:  {xs: '250px', sm: '260px', md: '400px'},
          left: {sm: '0', md: '-35px'},
          position: 'relative',
          gap: {sm: '10px', md: '90px'}
        }}>
          <ButtonOther
              onClick={handleButtonClickMedia}>
            {t('hero_a3')} <ArrowRightAltRoundedIcon/>
          </ButtonOther>
          <ButtonRitual
             onClick={handleButtonClick}>
            {t('hero_a')} <ArrowRightAltRoundedIcon/>
          </ButtonRitual>
          {/*<ButtonOther*/}
          {/*   onClick={handleButtonClick}>*/}
          {/*  {t('hero_a2')} <ArrowRightAltRoundedIcon/>*/}
          {/*</ButtonOther>*/}
        </Stack>
      </ContentWrapper>
    </StyledHero>
  );
};

export default Hero;
